'use client';

import React from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  navigationMenuTriggerStyle,
} from '@/components/ui/navigation-menu';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslations } from 'next-intl';
import Logo from '@public/webtrixLogoSBijelimTextom.svg';
import styles from './index.module.scss';
import Link from 'next/link';
import Image from 'next/image';
import LocaleSwitcher from '@/components/LocaleSwitcher';
import useNavbarMobileAnimation from './useNavbarMobileAnimation';

const NavbarMobileAnimation = () => {
  const t = useTranslations('navigation');
  const { showModal, toggleModal, handleNavigation, modalVariants } =
    useNavbarMobileAnimation();

  const navLinks = [
    { title: t('services'), targetSection: 'services', id: 1 },
    { title: t('about'), targetSection: 'about', id: 2 },
    { title: t('approach'), targetSection: 'approach', id: 3 },
    { title: t('technology'), targetSection: 'skills', id: 4 },
    { title: t('getInTouch'), targetSection: 'contact', id: 5 },
  ];

  return (
    <nav
      className={`${showModal ? styles.container : ''} `}
      data-id="home"
      id="home"
    >
      <div
        className={`${styles.background} container mx-auto flex justify-between items-center py-2 pl-5 max-w-[1200px]`}
      >
        <Link href="/" className="text-white font-bold text-xl">
          <Image src={Logo} alt="logo" width={70} height={70} />
        </Link>

        <div className="flex justify-center items-center">
          <ul className={styles.mobileNav}>
            <li onClick={toggleModal}>
              <FaBars />
            </li>
          </ul>

          <NavigationMenu className={styles.desktopNav}>
            <NavigationMenuList>
              {navLinks.map((link) => (
                <NavigationMenuItem key={link.id}>
                  <NavigationMenuLink
                    href={`/#${link.targetSection}`}
                    className={navigationMenuTriggerStyle()}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavigation(link.targetSection);
                    }}
                  >
                    {link.title}
                  </NavigationMenuLink>
                </NavigationMenuItem>
              ))}
            </NavigationMenuList>
            <LocaleSwitcher align="end" />
          </NavigationMenu>
        </div>
      </div>

      <AnimatePresence>
        {showModal && (
          <motion.div
            className="fixed inset-0 flex justify-center items-center bg-gray-900 z-20"
            variants={modalVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            <div
              className="absolute top-0 right-0 p-4 cursor-pointer"
              onClick={toggleModal}
            >
              <FaTimes className="text-white" style={{ fontSize: '16px' }} />
            </div>

            <div className="relative bg-gray-900 w-full">
              <div className="flex flex-col gap-8 items-center justify-center h-full ">
                {navLinks.map((link) => (
                  <span
                    key={link.id}
                    className="text-white font-light text-xl cursor-pointer hover:text-[#1efcf9bf] focus:text-[#1efcf9bf] ease-in-out duration-300"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleModal();
                      handleNavigation(link.targetSection);
                    }}
                  >
                    {link.title}
                  </span>
                ))}
                <LocaleSwitcher showLanguage />
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default NavbarMobileAnimation;
